import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=0fbb1d9e"
import script from "./Options.vue?vue&type=script&lang=ts"
export * from "./Options.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports